<template>
  <div class="patient-drawer-layer" @click.self="$emit('close')">
    <aside class="patient-drawer" role="dialog" aria-modal="true" aria-labelledby="patient-drawer-title">
      <button class="patient-drawer-close" type="button" aria-label="Fermer" @click="$emit('close')">
        <icon width="14" height="14" name="times"></icon>
      </button>
      <div v-if="loading" class="patient-drawer-loading">Chargement…</div>
      <template v-else-if="patient">
        <h2 id="patient-drawer-title">{{ patient.pa_name || "Anonyme" }}</h2>
        <div class="patient-drawer-radio"><img :src="radioUrl" alt="Radiographie du patient" /></div>
        <div class="patient-drawer-details">
          <span v-if="patient.pa_sex == 1">Homme</span><span v-else-if="patient.pa_sex == 2">Femme</span>
          <span v-if="age !== null">{{ age }} ans</span><span v-if="patient.pa_weight">{{ patient.pa_weight }} Kg</span>
          <span v-if="patient.pa_height">{{ patient.pa_height }} cm</span>
          <span v-if="patient.pa_lateralite">{{ patient.pa_lateralite === "right" ? "Droite" : "Gauche" }}</span>
        </div>
        <div v-if="patient.pa_cotyle" class="patient-drawer-product">
          {{ patient.pa_cotyle.pr_model }} {{ patient.pa_cotyle.pr_subtype }} - Ø{{ patient.pa_cotyle.pr_size }}mm
        </div>
        <div v-if="patient.pa_tige" class="patient-drawer-product">
          {{ patient.pa_tige.pr_model }} {{ patient.pa_tige.pr_subtype }} - {{ patient.pa_tige.pr_size }}mm
        </div>
        <div class="patient-drawer-actions">
          <button class="btn btn-primary" type="button" @click="showResult">Résultat</button>
          <button class="btn btn-primary" type="button" @click="print">Imprimer</button>
        </div>
        <div v-if="missingPostOpReport" class="patient-drawer-warning">Manque CR post-op</div>
      </template>
    </aside>
  </div>
</template>

<script>
export default {
  name: "patient-drawer",
  props: { patientId: { type: [Number, String], required: true } },
  data() { return { patient: null, loading: true }; },
  computed: {
    age() {
      if (!this.patient.pa_birthdate || this.patient.pa_birthdate === "0000-00-00") return null;
      return this.$dayjs().diff(this.$dayjs(this.patient.pa_birthdate), "year");
    },
    radioUrl() {
      return `${this.$config.server_url}/api/1.0/files/patient/${this.patientId}?token=${this.$store.state.accesstoken}&origin=webapp`;
    },
    missingPostOpReport() { return !this.patient.files || this.patient.files.length === 0; }
  },
  async mounted() {
    document.body.classList.add("patient-drawer-open");
    document.addEventListener("keydown", this.onKeydown);
    try {
      const response = await this.$axios.get(`${this.$config.server_url}/api/1.0/patients/${this.patientId}`);
      this.patient = response.data.data;
    } finally { this.loading = false; }
  },
  beforeDestroy() {
    document.body.classList.remove("patient-drawer-open");
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(event) { if (event.key === "Escape") this.$emit("close"); },
    showResult() { this.$router.push(`/result/${this.patientId}`).catch(() => {}); },
    print() {
      window.open(`${this.$config.server_url}/api/1.0/patients/${this.patientId}/print?token=${this.$store.state.accesstoken}&origin=webapp&d=${Date.now()}`);
    }
  }
};
</script>

<style lang="scss">
body.patient-drawer-open { overflow: hidden; }
.patient-drawer-layer { position: fixed; inset: 0; z-index: 10010; background: rgba(20, 20, 25, 0.58); }
.patient-drawer {
  position: absolute; top: 0; right: 0; width: 390px; max-width: 100vw; height: 100%; overflow-y: auto;
  padding: 38px 28px 26px; background: #fff; box-shadow: -8px 0 24px rgba(0, 0, 0, 0.18);
  animation: patient-drawer-in 220ms ease-out;
}
.patient-drawer h2 { margin: 0 32px 14px 0; color: #292929; font-size: 1.15rem; font-weight: 700; }
.patient-drawer-close {
  position: absolute; top: 14px; right: 14px; display: flex; width: 28px; height: 28px; align-items: center;
  justify-content: center; border: 0; border-radius: 50%; background: #71879a; color: white; cursor: pointer;
}
.patient-drawer-radio { height: 430px; max-height: 54vh; min-height: 240px; overflow: hidden; border-radius: 9px; background: #080808; }
.patient-drawer-radio img { width: 100%; height: 100%; object-fit: contain; }
.patient-drawer-details { display: flex; flex-wrap: wrap; margin-top: 12px; font-size: 0.78rem; }
.patient-drawer-details span:not(:last-child)::after { content: " | "; white-space: pre; }
.patient-drawer-product { font-size: 0.78rem; line-height: 1.35; }
.patient-drawer-actions { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-top: 24px; }
.patient-drawer-warning { margin-top: 7px; color: #c6091f; font-size: 0.72rem; }
.patient-drawer-loading { display: flex; height: 100%; align-items: center; justify-content: center; }
@keyframes patient-drawer-in { from { transform: translateX(100%); } to { transform: translateX(0); } }
@media (max-width: 575px) { .patient-drawer { padding: 28px 20px 22px; } }
@media (prefers-reduced-motion: reduce) { .patient-drawer { animation: none; } }
</style>
